@if (client(); as client) {
  <div class="flex flex-row items-center pb-4">
    <app-page-header>Settings</app-page-header>
  </div>

  <div class="vertical-tabs-layout">
    <nav
      class="vertical-tabs"
      aria-label="Settings sections"
      aria-orientation="vertical"
      role="tablist"
    >
      <button
        id="basic-info-tab"
        type="button"
        class="vertical-tab"
        (click)="selectTab(eSettingsTab.BasicInfo)"
        [attr.aria-selected]="selectedTab() === eSettingsTab.BasicInfo"
        [class.vertical-tab-active]="selectedTab() === eSettingsTab.BasicInfo"
        aria-controls="basic-info-panel"
        role="tab"
      >
        Basic Info
      </button>

      <button
        id="connections-tab"
        type="button"
        class="vertical-tab"
        (click)="selectTab(eSettingsTab.Connections)"
        [attr.aria-selected]="selectedTab() === eSettingsTab.Connections"
        [class.vertical-tab-active]="selectedTab() === eSettingsTab.Connections"
        aria-controls="connections-panel"
        role="tab"
      >
        Connections
      </button>

    </nav>
    <mat-card class="card vertical-tabs-panel">
      @switch (selectedTab()) {
        @case (eSettingsTab.BasicInfo) {
          <avs-inline-input
            (updated)="updateClientData({ friendlyName: $event }, client)"
            [disabled]="userRole() !== eUserRolesIds.SuperAdmin"
            [showToast]="false"
            [value]="client.friendlyName"
            label="Client Name"
            placeholder="Client Name"
          />
          <div class="mb-5">
            <avs-two-way-communication [client]="client" />
          </div>
          <avs-phone-number [client]="client" />

          <avs-session-timeout [client]="client" />

          @if ('totp' | avsFeatureFlag) {
            <avs-require-totp [client]="client" />
          }
        }
        @case (eSettingsTab.Connections) {
          <avs-connections />
        }
      }
      <avs-device-licensing
        [client]="client"
        [userRole]="userRole()"
      />
    </mat-card>
  </div>
}
